import React, { useState, useEffect } from 'react';
import { 
  Container, Dialog, DialogContent, DialogTitle, DialogActions, TextField, Typography, 
  Button, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Box,
  IconButton, Card, CardContent, useMediaQuery, useTheme, Chip, Divider, InputAdornment
} from '@mui/material';
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, PEDIDOSLISTS, PEDIDOSDETALLESVER, PEDIDO_ESTADO, VENTAALTA } from '../services/apiConfig';
import { DataGrid } from '@mui/x-data-grid';
import Cargando from './utils/Cargando.jsx';
import axios from 'axios';
import { format, parse } from 'date-fns';
import esLocale from 'date-fns/locale/es';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerStyles.css';
import * as XLSX from 'xlsx';
import { 
  SaveAlt, Search, Close, CalendarToday, ShoppingBag,
  Phone, Email, LocationOn, Person, AttachMoney, Visibility,
  LocalShipping
} from '@mui/icons-material';

// Función para formatear moneda
const formatCurrency = (value) => {
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value || 0);
};

 const getAuthHeaders = () => {
    const token = sessionStorage.getItem('authToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

function PedidosList() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const sucursalid = userData?.sucursalid;
  const sucursalnombre = userData?.sucursalnombre;
  const usuarioid = userData?.usuarioid;
  
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [verIDPedido, setVerIDPedido] = useState('');
  const [verFechaPedido, setVerFechaPedido] = useState('');
  const [verHoraPedido, setVerHoraPedido] = useState('');
  const [total, setTotal] = useState(0);
  const [orderDetails, setOrderDetails] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [observacion, setObservacion] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [convertirVentaOpen, setConvertirVentaOpen] = useState(false);
  const [pedidoAConvertir, setPedidoAConvertir] = useState(null);
  const [loadingConvertir, setLoadingConvertir] = useState(false);

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    fetchPedidos(formattedDate, formattedDate);
  }, []);

  const columns = [
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 180,
      renderCell: (params) => {
        const estado = params.row.estado || 'pendiente';
        return (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Button size="small" onClick={() => handleVer(params.row)}>Ver</Button>
          {estado === 'pendiente' && (
            <Button 
              size="small" 
              color="warning" 
              onClick={() => cambiarEstado(params.row.id, 'preparado')}
            >
              Preparar
            </Button>
          )}
          {estado === 'preparado' && (
            <Button 
              size="small" 
              color="success" 
              onClick={() => cambiarEstado(params.row.id, 'enviado')}
            >
              Enviar
            </Button>
          )}
        </Box>
        );
      },
    },
    { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'fecha', 
      headerName: 'Fecha', 
      width: 155,
      valueFormatter: (params) => {  
        const fecha = new Date(params.value);
        return fecha.toLocaleDateString('es-ES', {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit', hour12: false,
        });
      }
    },
    { 
      field: 'estado', 
      headerName: 'Estado', 
      width: 120,
      renderCell: (params) => {
        const colors = {
          pendiente: 'warning',
          preparado: 'info',
          enviado: 'success',
          entregado: 'default',
          cancelado: 'error'
        };
        return <Chip label={params.value} color={colors[params.value] || 'default'} size="small" />;
      }
    },
    { field: 'nombre', headerName: 'Local', width: 80 },
    { field: 'cliente', headerName: 'Cliente', width: 130 },
    { field: 'direccion', headerName: 'Dirección', width: 200 },
    { field: 'telefono', headerName: 'Teléfono', width: 120 },
    { 
      field: 'total', 
      headerName: 'Total', 
      width: 100,
      renderCell: (params) => formatCurrency(params.value || 0)
    },
  ]; 

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    const filteredData = users.filter((user) =>
      user.email.toLowerCase().includes(term.toLowerCase()) ||
      user.cliente.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredUsers(filteredData);
  };

  const cambiarEstado = async (pedidoId, nuevoEstado) => {
    if (nuevoEstado === 'enviado') {
      const pedido = users.find(u => u.id === pedidoId);
      if (pedido) {
        setPedidoAConvertir(pedido);
        setConvertirVentaOpen(true);
      }
      return;
    }
    
    await cambiarEstadoAPI(pedidoId, nuevoEstado);
  };

  const convertirAVenta = async () => {
    if (!pedidoAConvertir) return;
    setLoadingConvertir(true);
    
    try {
      const responseDetalles = await axios.get(API_BASE_URL + PEDIDOSDETALLESVER + '?pedido=' + pedidoAConvertir.id);
      const detalles = Array.isArray(responseDetalles.data) ? responseDetalles.data : [];
      
      if (detalles.length > 0) {
        const precioEnvio = parseFloat(pedidoAConvertir.precio_envio) || 0;
        const totalSinEnvio = detalles.reduce((sum, d) => sum + (parseFloat(d.cantidad) * parseFloat(d.precio)), 0);
        const totalConEnvio = totalSinEnvio + precioEnvio;
        
        const ventaData = {
          fecha: new Date().toISOString().slice(0, 19).replace('T', ' '),
          sucursal_id: sucursalid,
          cliente: pedidoAConvertir.cliente,
          total: totalConEnvio,
          descuento: 0,
          metodo_pago: 'efectivo',
          estado: 'completada',
          observaciones: `Pedido #${pedidoAConvertir.id} - ${pedidoAConvertir.comentarios || ''}`,
          tipo_venta: 'delivery',
          productos: detalles.map(d => ({
            producto_id: d.producto_id,
            cantidad: parseInt(d.cantidad),
            precio_unitario: parseFloat(d.precio),
            observaciones: d.observaciones || null
          }))
        };
        
        await axios.post(API_BASE_URL + VENTAALTA, ventaData);
      }
      
      setConvertirVentaOpen(false);
      await cambiarEstadoAPI(pedidoAConvertir.id, 'enviado');
      setPedidoAConvertir(null);
      setLoadingConvertir(false);
    } catch (error) {
      console.error('Error:', error);
      setLoadingConvertir(false);
      alert('Error al convertir a venta');
    }
  };

  const cambiarEstadoAPI = async (pedidoId, nuevoEstado) => {
    try {
      const response = await axios.post(API_BASE_URL + PEDIDO_ESTADO, {
        pedido_id: pedidoId,
        estado: nuevoEstado
      });
      
      if (response.data.success) {
        const today = new Date();
        const fecha = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        fetchPedidos(fecha, fecha);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al cambiar estado');
    }
  };

  const exportToExcel = () => {
    const fileName = 'pedidos.xlsx';
    const data = users.map(user => ({
      ID: user.id,
      Fecha: user.fecha,
      Local: user.nombre,
      Cliente: user.cliente,
      Dirección: user.direccion,
      Teléfono: user.telefono,
      Mail: user.email,
      Abonacon: user.abonacon,
      Comentarios: user.comentarios,
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Pedidos');
    XLSX.writeFile(wb, fileName);
  };

  const handleVer = (pedido) => {
    setSelectedUser(pedido);
    setVerIDPedido(pedido.id);
    setVerFechaPedido(format(parse(pedido.fecha, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd/MM/yyyy'));
    setVerHoraPedido(format(parse(pedido.fecha, 'yyyy-MM-dd HH:mm:ss', new Date()), 'HH:mm'));
  
    axios.get(API_BASE_URL + PEDIDOSDETALLESVER + '?pedido=' + pedido.id)
      .then((response) => {
        if (response && response.data) {
          setOrderDetails(response.data);
          const totalPrice = response.data.reduce((accumulator, detail) => {
            return accumulator + detail.precio * detail.cantidad;
          }, 0);
          setTotal(totalPrice);
          setIsDialogOpen(true);
        }
      })
      .catch((error) => {
        console.error('Error al cargar los detalles del pedido', error);
      });
  };

  const fetchPedidos = (startDate, endDate) => {
    const today = new Date();
    const fecha = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    const start = startDate || fecha;
    const end = endDate || fecha;
    
  axios.get(`${API_BASE_URL}${PEDIDOSLISTS}?s=${sucursalid}&startDate=${start}&endDate=${end}`, { 
    headers: getAuthHeaders() 
}) 
.then((response) => {
    const userData = response.data;
    setUsers(userData);
    setFilteredUsers(userData);
    setLoading(false);
})
.catch((error) => {
    console.error('Error al cargar los pedidos', error);
    setLoading(false);
});
  };

  const handleUpdateData = () => {
    setLoading(true);
    const formattedStartDate = startDate ? startDate.toISOString() : null;
    const formattedEndDate = endDate ? endDate.toISOString() : null;
    fetchPedidos(formattedStartDate, formattedEndDate);
  };

  // ==========================================
  // VISTA MÓVIL CON CARDS
  // ==========================================
  const MobileView = () => (
    <Box sx={{ pb: 10 }}>
      {/* Header sticky */}
      <Paper elevation={2} sx={{ p: 2, mb: 2, position: 'sticky', top: 56, zIndex: 100 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            <ShoppingBag sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
            Pedidos
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {filteredUsers.filter(u => u.estado === 'pendiente').length > 0 && (
              <Chip label={`${filteredUsers.filter(u => u.estado === 'pendiente').length} pendientes`} color="warning" size="small" />
            )}
            <Chip label={`${filteredUsers.length} total`} color="primary" size="small" />
          </Box>
        </Box>

        <TextField
          placeholder="Buscar por cliente o email..."
          variant="outlined"
          fullWidth
          size="small"
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 1.5 }}
        />

        <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
          <DatePicker
            onChange={(date) => setStartDate(date)}
            dateFormat="dd/MM/yyyy"
            locale={esLocale}
            selected={startDate || new Date()}
            maxDate={new Date()}
            customInput={
              <TextField 
                size="small" 
                fullWidth 
                InputProps={{
                  startAdornment: <CalendarToday sx={{ mr: 1, fontSize: '1rem', color: 'text.secondary' }} />
                }}
              />
            }
          />
          <DatePicker
            onChange={(date) => setEndDate(date)}
            dateFormat="dd/MM/yyyy"
            locale={esLocale}
            selected={endDate || new Date()}
            maxDate={new Date()}
            customInput={
              <TextField 
                size="small" 
                fullWidth 
                InputProps={{
                  startAdornment: <CalendarToday sx={{ mr: 1, fontSize: '1rem', color: 'text.secondary' }} />
                }}
              />
            }
          />
        </Box>

        <Button variant="contained" fullWidth onClick={handleUpdateData} size="small">
          Actualizar
        </Button>
      </Paper>

      {/* Lista de pedidos en cards */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {filteredUsers.map((pedido) => (
          <Card 
            key={pedido.id}
            sx={{ 
              transition: 'all 0.2s',
              '&:hover': { boxShadow: 4 }
            }}
          >
            <CardContent sx={{ p: 2 }}>
              {/* Header del card */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                    Pedido #{pedido.id}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                    {new Date(pedido.fecha).toLocaleDateString('es-ES', {
                      day: '2-digit', month: 'short', year: 'numeric',
                      hour: '2-digit', minute: '2-digit'
                    })}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Chip 
                    label={pedido.estado || 'pendiente'}
                    color={(pedido.estado || 'pendiente') === 'pendiente' ? 'warning' : (pedido.estado || 'pendiente') === 'preparado' ? 'info' : 'success'}
                    size="small"
                    sx={{ fontSize: '0.65rem', height: 22 }}
                  />
                  <Chip 
                    label={pedido.nombre}
                    color="primary"
                    size="small"
                    sx={{ fontSize: '0.65rem', height: 22 }}
                  />
                </Box>
              </Box>

              {/* Información del cliente */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Person sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                  <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500 }}>
                    {pedido.cliente}
                  </Typography>
                </Box>
                
                {pedido.direccion && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                    <LocationOn sx={{ fontSize: '1rem', color: 'text.secondary', mt: 0.2 }} />
                    <Typography variant="body2" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                      {pedido.direccion}
                    </Typography>
                  </Box>
                )}
                
                {pedido.telefono && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Phone sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                    <Typography variant="body2" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                      {pedido.telefono}
                    </Typography>
                  </Box>
                )}
                
                {pedido.email && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Email sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                    <Typography variant="body2" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                      {pedido.email}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Botones de acción */}
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  startIcon={<Visibility />}
                  onClick={() => handleVer(pedido)}
                >
                  Ver
                </Button>
                {pedido.estado === 'preparado' && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => cambiarEstado(pedido.id, 'enviado')}
                  >
                    Enviar
                  </Button>
                )}
                {pedido.estado === 'pendiente' && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="warning"
                    size="small"
                    onClick={() => cambiarEstado(pedido.id, 'preparado')}
                  >
                    Preparar
                  </Button>
                )}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Mensaje si no hay pedidos */}
      {filteredUsers.length === 0 && !loading && (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <ShoppingBag sx={{ fontSize: 80, color: 'grey.300', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            No se encontraron pedidos
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Intenta con otras fechas o búsqueda
          </Typography>
        </Box>
      )}
    </Box>
  );

  // ==========================================
  // VISTA DESKTOP CON TABLA
  // ==========================================
  const DesktopView = () => {
    const pendientes = users.filter(u => u.estado === 'pendiente').length;
    return (
    <Box>
      <Box className='miDiv'>
        <h2>Pedidos de la sucursal {sucursalnombre}</h2>
        {pendientes > 0 && <Chip label={`${pendientes} pendientes`} color="warning" sx={{ ml: 2 }} />}
      </Box>

      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <DatePicker
          onChange={(date) => setStartDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Fecha de inicio"
          locale={esLocale}
          selected={startDate || new Date()}
          maxDate={new Date()}
        />
        <DatePicker
          onChange={(date) => setEndDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Fecha de fin"
          locale={esLocale}
          selected={endDate || new Date()}
          maxDate={new Date()} 
        />
        <Button onClick={handleUpdateData} variant="contained" color="primary">
          Actualizar
        </Button>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <TextField
          label="Buscar por Cliente o Mail"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <IconButton onClick={exportToExcel} color="success">
          <SaveAlt />
        </IconButton>
      </Box>

<div style={{ height: 600, width: '100%' }}>
        <DataGrid rows={filteredUsers} columns={columns} getRowId={(row) => row.id} />
      </div>
    </Box>
  );
};

  return (
    <Container maxWidth={isMobile ? false : 'xl'} sx={{ px: isMobile ? 1 : 3 }}>
      <MenuInicial />

      {loading ? (
        <Cargando />
      ) : (
        isMobile ? <MobileView /> : <DesktopView />
      )}

      {/* Diálogo de detalle del pedido */}
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Detalle Pedido #{verIDPedido}
          <IconButton onClick={() => setIsDialogOpen(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography><strong>Fecha:</strong> {verFechaPedido}</Typography>
            <Typography><strong>Hora:</strong> {verHoraPedido}</Typography>
            {selectedUser && (
              <>
                <Typography><strong>Cliente:</strong> {selectedUser.cliente}</Typography>
                <Typography><strong>Dirección:</strong> {selectedUser.direccion}</Typography>
                <Typography><strong>Teléfono:</strong> {selectedUser.telefono}</Typography>
                <Typography><strong>Email:</strong> {selectedUser.email}</Typography>
              </>
            )}
          </Box>

          <Typography variant="h6" gutterBottom>Productos</Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Producto</TableCell>
                  <TableCell align="right">Cant.</TableCell>
                  <TableCell align="right">Precio</TableCell>
                  <TableCell align="right">Subtotal</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderDetails.map((detail, index) => (
                  <TableRow key={index}>
                    <TableCell>{detail.nombre}</TableCell>
                    <TableCell align="right">{detail.cantidad}</TableCell>
                    <TableCell align="right">${formatCurrency(detail.precio)}</TableCell>
                    <TableCell align="right">${formatCurrency(detail.cantidad * detail.precio)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={3} align="right"><strong>Precio de envío:</strong></TableCell>
                  <TableCell align="right">
                    <strong>${formatCurrency(orderDetails.find(detail => detail.precio_envio !== undefined)?.precio_envio || 0)}</strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3} align="right"><strong>Total:</strong></TableCell>
                  <TableCell align="right">
                    <strong>
                      ${formatCurrency(
                        orderDetails.reduce((total, detail) => total + detail.cantidad * detail.precio, 0) +
                        Number(orderDetails.find(detail => detail.precio_envio !== undefined)?.precio_envio || 0)
                      )}
                    </strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDialogOpen(false)} variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={convertirVentaOpen} onClose={() => setConvertirVentaOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
          <ShoppingBag sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
          <Typography variant="h6" fontWeight="bold">Confirmar Venta</Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ¿Querés convertir este pedido en una venta de tipo <Chip label="Delivery" color="primary" size="small" />?
          </Typography>
          {pedidoAConvertir && (
            <Card variant="outlined" sx={{ p: 2, mb: 2, bgcolor: 'grey.50' }}>
              <Typography variant="subtitle2" color="text.secondary">Cliente</Typography>
              <Typography variant="body1" fontWeight="bold">{pedidoAConvertir.cliente}</Typography>
              {pedidoAConvertir.direccion && (
                <>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>Dirección</Typography>
                  <Typography variant="body2">{pedidoAConvertir.direccion}</Typography>
                </>
              )}
              {pedidoAConvertir.telefono && (
                <>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>Teléfono</Typography>
                  <Typography variant="body2">{pedidoAConvertir.telefono}</Typography>
                </>
              )}
            </Card>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0, gap: 1 }}>
          <Button 
            fullWidth 
            variant="outlined" 
            onClick={() => setConvertirVentaOpen(false)}
            sx={{ py: 1.5 }}
          >
            Cancelar
          </Button>
          <Button 
            fullWidth 
            variant="contained" 
            onClick={convertirAVenta}
            disabled={loadingConvertir}
            sx={{ py: 1.5 }}
          >
            {loadingConvertir ? 'Convirtiendo...' : 'Confirmar Venta'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default PedidosList;
